// extracted by mini-css-extract-plugin
export default {"line":"SplitLineDesktop_line__aZMgY"};